"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var graphql_request_1 = require("graphql-request");

var framework_1 = require("../../core/framework");

var Repository =
/** @class */
function (_super) {
  __extends(Repository, _super);

  function Repository() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Repository.prototype.getMarketInfo = function (marketId, domain) {
    return this.request(graphql_request_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        query GetMarketInfo($input: PublicMarketInput!) {\n          publicMarket(input: $input) {\n            id\n            isActive\n            analyticWriteKey\n            defaultPlaceId\n            licenceId\n            logoUrl\n            businessAccounts {\n              minOrderSum\n            }\n          }\n        }\n      "], ["\n        query GetMarketInfo($input: PublicMarketInput!) {\n          publicMarket(input: $input) {\n            id\n            isActive\n            analyticWriteKey\n            defaultPlaceId\n            licenceId\n            logoUrl\n            businessAccounts {\n              minOrderSum\n            }\n          }\n        }\n      "]))), {
      input: {
        marketId: marketId || null,
        domain: domain || null
      }
    });
  };

  return Repository;
}(framework_1.RepositoryBase);

exports.default = Repository;
var templateObject_1;